import React, { ReactElement, useState } from 'react';
import { Card, Layout, Button, Row } from 'antd';
import { Redirect } from 'react-router-dom';
const { Content } = Layout;
const FailedEmailValidation = (): ReactElement => {
  const [redirectState, changeRedirectState] = useState(false);
  const getBackSignin = (): void => {
    changeRedirectState(true);
  };
  return (
    <>
      {redirectState && (
        <Redirect from={`/successfulEmailValidation`} to={`/`} />
      )}
      {!redirectState && (
        <Layout style={{ minHeight: '100vh' }}>
          <Content style={{ minHeight: '100vh', padding: '10% 39%' }}>
            <Row className="cards">
              <Card>
                <Row>Your Email has Not been validated.</Row>
                <Row style={{ padding: '1% 3%' }}>
                  <Button key="1" type="primary" danger onClick={getBackSignin}>
                    Return to the main page
                  </Button>
                </Row>
              </Card>
            </Row>
          </Content>
        </Layout>
      )}
    </>
  );
};

export default FailedEmailValidation;
